// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const navConfig = [
  {
    title: 'home',
    path: '/client/home',
    icon: icon('ic_home'),
  },
  {
    title: 'business',
    path: '/client/business',
    icon: icon('ic_analytics'),
  },
  {
    title: 'companies',
    path: '/client/companies',
    icon: icon('ic_blog'),
  },
  {
    title: 'users',
    path: '/client/user',
    icon: icon('ic_user'),
  },
  // {
  //   title: 'product',
  //   path: '/client/products',
  //   icon: icon('ic_cart'),
  // },
  // {
  //   title: 'login',
  //   path: '/login',
  //   icon: icon('ic_lock'),
  // },
  // {
  //   title: 'Not found',
  //   path: '/404',
  //   icon: icon('ic_disabled'),
  // },
];

export default navConfig;
